module.exports = function() {
  return new Worker(__webpack_public_path__ + "dfbe2b1a24aa1b834a9d.worker.js");
};